import axios from 'axios';

const axiosInstance = axios.create({
    headers: {
        ['x-api-key'] : "60dd465d-4e37-4b3f-b218-dab97f1a3282",
    },
    baseURL: 'https://api.thedogapi.com/v1/'
});

export default axiosInstance;